import React from 'react';
import intermediateImg from '../assets/images/choirs/intermediate.jpg';
import juniorP1Img from '../assets/images/choirs/juniorP1.jpg';
//import juniorP5Img from '../assets/images/choirs/juniorP5.jpg';
import seniorImg from '../assets/images/choirs/senior.jpg';
import varsityImg from '../assets/images/choirs/varsity.jpg';
import vocalEnsembleImg from '../assets/images/choirs/vocalEnsemble.jpg';

function ChoirSlider() {
	const [choir, setChoir] = React.useState({});

	const junior = {
		name: 'Junior Chorus',
		img: juniorP1Img,
		description:
			'This is a beginner level ensemble for those singing for the first time at Marshall (No audition required). In this chorus, we build the foundation for note reading, vocal technique, and musicianship skills. This ensemble performs in two concerts a year and takes part in the annual school musical.',
	};
	const intermediate = {
		name: 'Intermediate Chorus',
		img: intermediateImg,
		description:
			"This is an intermediate, treble ensemble for 2nd year Soprano's and Alto's at Marshall. In this chorus, we grow in our skills of note reading, vocal technique, and musicianship skills. This ensemble performs in two concerts a year and takes part in our annual school musical.",
	};
	const varsity = {
		name: 'Varsity Chorus',
		img: varsityImg,
		description:
			'This is an intermediate/advanced, lower voice ensemble for 2nd and 3rd year Tenor and Basses at Marshall. In this chorus, we grow in our skills of note reading, vocal technique, and musicianship skills to prepare for high school level performance. This ensemble performs in two concerts a year and takes part in our annual school musical.',
	};
	const senior = {
		name: 'Senior Chorus',
		img: seniorImg,
		description:
			"This is an advanced, treble ensemble for 3rd year Soprano's and Alto's at Marshall. In this chorus, we grow in our skills of note reading, vocal technique, and musicianship skills to prepare for high school level performance. This ensemble performs in two concerts a year and takes part in our annual school musical.",
	};
	const vocalEnsemble = {
		name: 'Vocal Ensemble',
		img: vocalEnsembleImg,
		description:
			'This is an advanced, mixed ensemble for 2nd and 3rd year singers at Marshall (Must be enrolled in another choir above). In this chorus, we learn and perform high level music at a fast rate. This is an auditioned group that also does a vocal recording session at Disneyland every year. This group performs at our two concerts as well as any additional performance opportunities that may come during the year.',
	};

	React.useEffect(() => {
		setChoir(junior);
		// eslint-disable-next-line
	}, []);

	let choirArr = [junior, intermediate, varsity, senior, vocalEnsemble];

	const choirImages = choirArr.map((choir, i) => {
		return (
			<div
				key={i}
				className='carousel-item flex w-64 flex-col items-center gap-10 text-base-100'
			>
				<span className='font-bold text-accent'>{choir.name}</span>
				<img alt='choir photos' src={choir.img} className='rounded' />
				<div className='flex flex-col gap-4'>
					<h4 className='font-lora text-3xl font-bold'>{choir.name}</h4>
					<p>{choir.description}</p>
				</div>
			</div>
		);
	});

	return (
		<div className='flex flex-col items-center gap-10 bg-primary py-20 px-10'>
			<h2 className='font-lora text-5xl font-bold text-base-100'>Choirs</h2>
			<div className='carousel carousel-center max-w-sm space-x-8 bg-primary p-4 transition-all md:hidden '>
				{choirImages}
			</div>
			<div className='hidden flex-col md:flex'>
				<nav className='flex gap-12 font-bold text-base-100'>
					<button
						className={
							choir.name === 'Junior Chorus'
								? 'text-accent hover:text-base-100'
								: 'hover:text-accent'
						}
						onClick={() => setChoir(junior)}
					>
						Junior Chorus
					</button>
					<button
						className={
							choir.name === 'Intermediate Chorus'
								? 'text-accent hover:text-base-100'
								: 'hover:text-accent'
						}
						onClick={() => setChoir(intermediate)}
					>
						Intermediate Chorus
					</button>
					<button
						className={
							choir.name === 'Varsity Chorus'
								? 'text-accent hover:text-base-100'
								: 'hover:text-accent'
						}
						onClick={() => setChoir(varsity)}
					>
						Varsity Chorus
					</button>
					<button
						className={
							choir.name === 'Senior Chorus'
								? 'text-accent hover:text-base-100'
								: 'hover:text-accent'
						}
						onClick={() => setChoir(senior)}
					>
						Senior Chorus
					</button>
					<button
						className={
							choir.name === 'Vocal Ensemble'
								? 'text-accent hover:text-base-100'
								: 'hover:text-accent'
						}
						onClick={() => setChoir(vocalEnsemble)}
					>
						Vocal Ensemble
					</button>
				</nav>
				<div className='fade-in flex flex-col justify-center gap-20 py-12 text-base-100'>
					<div className='flex flex-col justify-center gap-4'>
						<h3 className='font-lora text-4xl font-bold'>{choir?.name}</h3>
						<p className='max-w-2xl'>{choir?.description}</p>
					</div>

					<div className='max-w-7xl'>
						<img alt={`${choir?.name}`} src={`${choir.img}`} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default ChoirSlider;
